<template>
  <div class="ad" :class="{ 'no-border': arguments.length < 1 || !isSidePanel }" v-if="!isSidePanel && !adsHidden">
    <div class="ads-holder" v-if="
      !adsHidden &&
      !adsRevContent &&
      !adsOutbrain &&
      !adsTaboola &&
      !adsDataBlocks &&
      !adsAditude
    ">
      <div v-if="adCode" v-html="adCode"></div>
      <template v-else>
        <div v-if="!isMobile()" class="ad-desktop" v-bind:id="adsAdSense ? 'div-gpt-ad-1619577812682-0' : 'dsk-sided-ad-a'
          "></div>
        <div v-if="isMobile()" class="ad-mobile" v-bind:id="adsAdSense ? 'div-gpt-ad-1619577431738-0' : 'mob-sided-ad-a'
          "></div>
        <div :id="getNextAvailableId('sided-ad-')"></div>
      </template>
    </div>

    <div class="ads-holder ads-rev-content" v-if="!adsHidden && adsRevContent">
      <div v-if="adCode" v-html="adCode"></div>
      <div v-else id="widget-pl-276130" data-widget-placement data-widget-host="habitat"
        data-endpoint="trends.revcontent.com" data-widget-id="276130" :data-sub-ids="adSubIds"
        data-banner-size="300x250">
      </div>
    </div>

    <div class="ads-holder ads-outbrain" v-if="!adsHidden && adsOutbrain">
      <div class="OUTBRAIN for-sided" :data-ob-contentUrl="getPageUrl()" :data-widget-id="isMobile() && adCodeMobile
        ? adCodeMobile.trim()
        : adCode
          ? adCode.trim()
          : getOutbrainAdId()
        " :data-external-id="getEmbedDomainId" data-ob-installation-key="SIDED224QF8GKMFPJJ9JPMD6K"></div>
    </div>

    <div class="ads-holder ads-taboola" v-if="!adsHidden && adsTaboola">
      <div v-if="adCode" v-html="adCode"></div>
      <iframe class="ads-taboola-iframe" v-else
        :src="`https://cdn.sided.co/embed-assets/taboola-loader.html?client=${clientDomain}`"></iframe>

    </div>

    <div class="ads-holder ads-datablocks" v-if="!adsHidden && adsDataBlocks">
      <div v-if="adCode" v-html="adCode"></div>
      <div v-else class="sided-data-blocks-unit" :data-datablocks_sid="debateClient.datablocksSid"></div>
    </div>
    <div class="ads-holder ads-adsAditude" v-if="!adsHidden && adsAditude">
      <div v-if="adCode" v-html="adCode"></div>
      <div v-else>
        <div :id="'pb-slot-incontent-' + instanceCounter" class="aditude-ad-container"
          style="width: 300px; height: 250px; min-height: 250px; background-color: #f0f0f0; display: flex; align-items: center; justify-content: center;">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainAdBox",
  data() {
    return {
      host: "",
      instanceCounter: 0
    };
  },
  props: {
    debate: {
      type: Object,
      default: null,
    },
    isSidePanel: {
      type: Boolean,
      default: false,
    },
  },
  inject: [
    "loadJs",
    "adCode",
    "adCodeMobile",
    "adSuffix",
    "isMobile",
    "arguments",
    "adsHidden",
    "getPageUrl",
    "adsAdSense",
    "adsTaboola",
    "adsAditude",
    "adsDataBlocks",
    "adsOutbrain",
    "debateClient",
    "debateHolder",
    "adsRevContent",
    "getOutbrainAdId",
    "aditudeAdCounter"
  ],
  methods: {
    getNextAvailableId(idPrefix) {
      const alphabet = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];

      for (let i in alphabet) {
        const id = idPrefix + alphabet[i];

        if (!document.querySelector(`#${id}`)) {
          return id;
        }
      }

      return "";
    },
  },
  computed: {
    adSubIds() {
      return `{ "domain": "${window.location.host}" }`;
    },
    taboolaPlacementClass() {
      return "taboola-mid-article-thumbnails";
    },
    getEmbedDomainId() {
      return window.sidedSessionData ? window.sidedSessionData.embedDomainId : 0;
    },
    clientDomain() {
      return window.location.host.replace('www.', '').replace('.com', '');
    }
  },
  created() {
    if (this.adsAditude) {
      if (window.aditudeAdCounter) {
        this.instanceCounter = window.aditudeAdCounter;
        window.aditudeAdCounter++;
      } else {
        this.instanceCounter = 1;
        window.aditudeAdCounter = 2;
      }
    }
  },
  mounted() {
    [...document.querySelectorAll(".sided-data-blocks-unit")].forEach(
      (unit, index) => {
        unit.setAttribute("id", `sided_unit_${index + 1}`);
      },
    );

    if (this.adsOutbrain) {
      setTimeout(() => {
        window.OBR.extern.researchWidget();
      }, 1000);
    }
    if (this.adsAditude) {
      window.tude = window.tude || { cmd: [] };

      window.tude.cmd.push(() => {
        window.tude.refreshAdsViaDivMappings([
          {
            divId: 'pb-slot-incontent-' + this.instanceCounter,
            baseDivId: 'pb-slot-incontent-1',
          }
        ]);
      });
    }
  },
};
</script>
